import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectResearchAssistantIsWaitingForResponse } from './selectors';
import { setIsWaitingForResponse } from './useResearchAssistantStore';

/**
 * Mirrors `researchAssistantSlice.isProcessing` (Redux) into the Zustand
 * store's `isWaitingForResponse` field. Mount once at app root.
 *
 * TODO: drop this once researchAssistantSlice (messages + progress + processing)
 * is fully migrated to a Zustand store. Tracked separately from OR-6025.
 */
export const useSyncIsWaitingForResponse = (): void => {
  const isProcessing = useSelector(selectResearchAssistantIsWaitingForResponse) ?? false;

  useEffect(() => {
    setIsWaitingForResponse(isProcessing);
  }, [isProcessing]);
};
